module.exports = __webpack_public_path__ + "static/img/part-value-bg.6939fcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part-value-bg.svg
// module id = Jpeb
// module chunks = 7